import { render } from "./Gmina.vue?vue&type=template&id=375ede38"
import script from "./Gmina.vue?vue&type=script&lang=js"
export * from "./Gmina.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Szymon\\witryny\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__